import React from 'react';
import { ChevronRight } from 'lucide-react';
import { css } from 'styled-system/css';

export default function ShaojiangBulletList({ items }: { items: string[] }) {
  return (
    <ul className={css({ mt: '2', ml: '-1' })}>
      {items.map((item) => (
        <li key={item} className={css({ display: 'flex', alignItems: 'flex-start', my: '1' })}>
          <ChevronRight
            size={18}
            className={css({
              color: 'primary.9',
              mr: { base: '2', smDown: '1' },
              mt: '0.5',
              flexShrink: 0,
            })}
          />
          <p>{item}</p>
        </li>
      ))}
    </ul>
  );
}
